define(()=> {
    return ['$q', 'JsonRPCService', 'qnb.endpointConfig', ($q, JsonRPCService, endpointConfig)=> {
        const endpoint = endpointConfig.emailEndpoint;
        return {
            emailQuote: (callGroups, quoteEmailDTO)=> {
                const deferred = $q.defer();
                JsonRPCService.send('quote', endpoint, 'emailQuote', [quoteEmailDTO], callGroups).then(
                    ()=> {
                        return deferred.resolve();
                    },
                    (error, status, headers)=> deferred.reject([error, status, headers]));
                return deferred.promise;
            }
        };
    }];
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/common/services/EmailService.js
 **/